import {createSelector} from 'reselect';
import {uniportalSelector} from 'modules/rootSelectors';

export const applicationsStateSelector = createSelector(uniportalSelector, uniportal => uniportal.applications || {});

export const applicationsSelector = createSelector(applicationsStateSelector, state => state.apps);

export const selectedAppIdSelector = createSelector(applicationsStateSelector, state => state.selectedAppId);

export const tokenStateSelector = createSelector(applicationsStateSelector, state => state.tokenIsSet);

export const errorFlagSelector = createSelector(applicationsStateSelector, state => state.error);

const findAppById = (appId, apps) => Array.isArray(apps) && apps.find(app => app.id == appId);

export const selectedApplicationSelector = createSelector(
    selectedAppIdSelector,
    applicationsSelector,
    findAppById
);

export const applicationSelector = applicationId => createSelector(
    applicationsSelector,
    apps => findAppById(applicationId, apps)
);

export const applicationBySlugSelector = applicationSlug => createSelector(
    applicationsSelector,
    apps => Array.isArray(apps) && apps.find(app => app.slug == applicationSlug)
);